module.exports = __webpack_public_path__ + "static/media/hero02.1701de33.jpg";